module.exports = __webpack_public_path__ + "static/media/ic_hs_b4_myway.8fa40ae5.svg";